import { createContext } from "react";

export const QuestionnaireFormContext = createContext({
  isRoomStayMaxReached: false,
  currentDependerType: "EXTRA",
});
